import { render, staticRenderFns } from "./VerifyEmailForm.vue?vue&type=template&id=1a18a65c&scoped=true"
import script from "./VerifyEmailForm.vue?vue&type=script&lang=js"
export * from "./VerifyEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a18a65c",
  null
  
)

export default component.exports